//This is the deprecated file, this is a cold dark storage file that will live forever
//There is no happiness here, you should leave and not look back
//One of the reasons this file exists is to prevent bloating the rest of the codebase

import { ZodDate, z } from "zod";

/**
 * @deprecated use TAnyDateFormatToJSDate instead
 */
export const TAnyDate = z.any().transform((raw) => {
  if (raw instanceof Date) return raw;
  if (typeof raw === "string") return new Date(raw);
  if (typeof raw === "number") return new Date(raw);
  if (typeof raw === "object" && raw.seconds)
    return new Date(raw.seconds * 1000);
  throw new Error("Invalid date");
});

/**
 * @deprecated use TDate instead
 */
export const TFirebaseTimestamp = z
  .union([
    z.object({
      seconds: z.number(),
    }),
    z.instanceof(Date),
  ])
  .transform((data) => {
    if (data instanceof Date) {
      return data;
    } else {
      return new Date(data.seconds * 1000);
    }
  }) as unknown as ZodDate;

/**
 * @deprecated use IDate instead
 */
export type IFirebaseTimestamp = z.infer<typeof TFirebaseTimestamp>;

/**
 * @deprecated use TAnyDateFormatToISOString instead
 */
export const TFirebaseTimestampToISO = z
  .object({
    seconds: z.number(),
  })
  .transform((raw) => {
    return new Date(raw.seconds * 1000).toISOString();
  });

/**
 * @deprecated use ITaskCustomField instead
 */
export type IDevationCustomField = z.infer<typeof TDeviationCustomField>;
/**
 * @deprecated use TTaskCustomField instead
 */
export const TDeviationCustomField = z.record(z.string(), z.any());
/**
 * @deprecated the type was not a custom field, use instead z.record(z.string(), z.any())
 */
export type ITaskCustomField = z.infer<typeof TTaskCustomField>;
/**
 * @deprecated the type was not a custom field, use instead z.record(z.string(), z.any())
 */
export const TTaskCustomField = z.record(z.string(), z.any());

/**
 * @deprecated Remove once `taskTypeID` field is in use
 */
export type IDeviationTaskType = z.infer<typeof TDeviationTaskType>;
/**
 * @deprecated Remove once `taskTypeID` field is in use
 */
export const TDeviationTaskType = z.enum(["deviation", "routine", "custom"]);
/**
 * @deprecated Remove once `taskTypeID` field is in use
 */
export const TTaskType = z.union([
  z.literal("deviation"),
  z.literal("routine"),
  z.literal("custom"),
]);
/**
 * @deprecated Remove once `taskTypeID` field is in use
 */
export type ITaskType = z.infer<typeof TTaskType>;
/**
 * @deprecated use TSeenBy instead
 */
export const TDeviationSeenBy = z.record(
  z.string(),
  z.object({
    date: TFirebaseTimestamp,
  })
);
/**
 * @deprecated use ISeenBy instead
 */
export type IDeviationSeenBy = z.infer<typeof TDeviationSeenBy>;
/**
 * @deprecated use ISeenBy instead
 */
export const TTaskSeenBy = z.record(
  z.string(),
  z.object({
    date: TFirebaseTimestamp,
  })
);
/**
 * @deprecated use ISeenBy instead
 */
export type ITaskSeenBy = z.infer<typeof TTaskSeenBy>;

/**
 * @deprecated use IVisibility instead
 */
export type IDeviationVisibility = z.infer<typeof TDeviationVisibility>;
/**
 * @deprecated use TVisibility instead
 */
export const TDeviationVisibility = z
  .object({
    landlords: z.boolean(),
    tenants: z.boolean(),
    allTenants: z.boolean(),
  })
  .partial();

/**
 * @deprecated use IVisibility instead
 */
export type ITaskVisibility = z.infer<typeof TTaskVisibility>;
/**
 * @deprecated use TVisibility instead
 */
export const TTaskVisibility = z
  .object({
    landlords: z.boolean(),
    tenants: z.boolean(),
    allTenants: z.boolean(),
  })
  .partial();

/**
 * @deprecated use ISeenBy instead
 */
export type IApiTaskSeenBy = z.infer<typeof TApiTaskSeenBy>;
/**
 * @deprecated use TSeenBy instead
 */
export const TApiTaskSeenBy = z.record(
  z.string(),
  z.object({
    date: z.string(),
  })
);
/**
 * @deprecated use ITaskInvoicedTo instead
 */
export const TDeviationInvoicedTo = z.object({
  companyID: z.string(),
  invoiceReceiverID: z.string(),
});
/**
 * @deprecated use ITaskInvoicedTo instead
 */
export type IDeviationInvoicedTo = z.infer<typeof TDeviationInvoicedTo>;
